import { api } from '@marketplace-web/core-api/core-api-client-util'

export const confirmComplaintResolved = (conversationId: number | string) =>
  api.patch(`/conversations/${conversationId}/complaint/confirm_resolved`)
